import {
    CREATE_CASH_TRANSACTION,
    FETCH_CASH_TRANSACTIONS,
    CLOSE_REGISTER,
    FETCH_CASH_SUMMARY,
    START_LOADING,
    END_LOADING,
  } from "../actions/constants";
  
  const initialState = {
    isLoading: false,
    transactions: [],
    summary: null,
  };
  
  const cashTransactions = (state = initialState, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true };
      case END_LOADING:
        return { ...state, isLoading: false };
      case CREATE_CASH_TRANSACTION:
        // Prepended: the list endpoint sorts newest-first ({date:-1}).
        return { ...state, transactions: [action.payload, ...state.transactions] };
      case FETCH_CASH_TRANSACTIONS:
        return { ...state, transactions: action.payload };
      case CLOSE_REGISTER:
        return { ...state, transactions: [action.payload, ...state.transactions] };
      case FETCH_CASH_SUMMARY:
        return { ...state, summary: action.payload };
      default:
        return state;
    }
  };
  
  export default cashTransactions;